import React, { useEffect } from 'react';

const Toast = ({ message, type, onClose }) => {
    useEffect(() => {
        const timer = setTimeout(() => {
            onClose();
        }, 5000);

        return () => clearTimeout(timer);
    }, [onClose]);

    return (
        <div className={`fixed bottom-4 left-4 z-50 px-4 py-3 rounded shadow-lg text-white ${
            type === 'error' ? 'bg-red-600' : 'bg-green-600'
        }`}>
            <div className="flex items-center justify-between">
                <span>{message}</span>
                <button 
                    onClick={onClose}
                    className="ml-4 text-white hover:text-gray-200 font-bold"
                >
                    ×
                </button>
            </div>
        </div>
    );
};

export default Toast;